import { generateDefaultSelectors } from "@/redux/selectors.utils";
import { IState } from "@/redux/store.types";
import { getApiDataState } from "@/redux/utils";

import { $PhonenumberPrefixesModuleName } from "./phonenumberPrefixes.types";

const { isLoading, isSuccessfullyLoaded } = generateDefaultSelectors(
    $PhonenumberPrefixesModuleName
);

const getPhonenumberPrefixes = (state: IState) => {
    return getApiDataState(state, $PhonenumberPrefixesModuleName)?.data || [];
};

export { getPhonenumberPrefixes, isLoading, isSuccessfullyLoaded };
